export const MICROSERVICES_NAMES = {
  AGREEMENTS: "agreements",
  BANNERS: "banners",
  FINANCES: "finances",
  MASS_SIGNING: "mass-siginig",
  MASS_PAY_WITH_LOAN: "registries-web",
  OPERATIONS: "operations",
  SPECIAL_OFFERS: "specialOffers",
  SPECIAL_OFFERS_TEMPLATES: "special-offers-templates",
  USER_SETTINGS: "user-settings",
  SBP: "sbp",
};

export const microserviceSettingsByName = {
  [MICROSERVICES_NAMES.AGREEMENTS]: {
    name: "agreements-access-web",
    groupKey: "agreements",
  },
  [MICROSERVICES_NAMES.BANNERS]: {
    name: "banners-access-web",
    groupKey: "main",
    systemId: "Лента сториз web",
  },
  [MICROSERVICES_NAMES.FINANCES]: {
    name: "finances-access-web",
    groupKey: "accounts",
  },
  [MICROSERVICES_NAMES.MASS_SIGNING]: {
    name: "owb-plt-ms-bso.enable-functionality.bulk-signing",
    groupKey: "signing",
  },
  [MICROSERVICES_NAMES.MASS_PAY_WITH_LOAN]: {
    name: "registries-web",
    groupKey: "rko",
  },
  [MICROSERVICES_NAMES.OPERATIONS]: {
    name: "operations-access-web",
    groupKey: "main",
  },
  [MICROSERVICES_NAMES.SBP]: {
    name: "sbp-button-enabled-web",
    groupKey: "main",
  },
  [MICROSERVICES_NAMES.SPECIAL_OFFERS]: {
    name: "special_offers_access_web",
    groupKey: "specials",
  },
  [MICROSERVICES_NAMES.SPECIAL_OFFERS_TEMPLATES]: {
    name: "rp-special-offers-access-web",
    groupKey: "specials",
  },
  [MICROSERVICES_NAMES.USER_SETTINGS]: {
    name: "user-settings-access-web",
    groupKey: "main",
  },
};
